const SCROLL_KEY = 'forum-industry.landing-scroll';

export function rememberLandingScroll() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SCROLL_KEY, String(window.scrollY));
  } catch {}
}

export function goBack() {
  if (typeof window === 'undefined') return;
  let saved = null;
  try {
    saved = sessionStorage.getItem(SCROLL_KEY);
  } catch {}

  history.pushState(null, '', '/');
  window.dispatchEvent(new PopStateEvent('popstate'));

  if (saved !== null) {
    try { sessionStorage.removeItem(SCROLL_KEY); } catch {}
    requestAnimationFrame(() =>
      requestAnimationFrame(() => window.scrollTo(0, parseInt(saved, 10)))
    );
  } else {
    window.scrollTo(0, 0);
  }
}
